import { ReferenceType } from '../../../types';
import { searchJmesPath } from '../../../utils';
import { IReferenceValue } from './helper';

/**
 * Transforms a full reference object to IReferenceValue format.
 * Extracts: id, modelId, version, and display (from data.name)
 */
export const transformToReferenceValue = (
  value: any,
  transformer?: string,
  type?: string
): IReferenceValue | IReferenceValue[] => {
  try {
    if (Array.isArray(value)) {
      return value.map((v: any) =>
        transformToReferenceValue(v, transformer)
      ) as IReferenceValue[];
    }

    if (!value || typeof value !== 'object') {
      return value;
    }

    // If it's already in the correct format, return as is
    if (
      value._formDisplayValue &&
      !value.data &&
      type !== ReferenceType.INTERNAL_REFERENCE
    ) {
      return value;
    }

    if (transformer) {
      const transformerPath = transformer.replace(/^\[.*?\]\.(?=\{)/, '');
      const transformed = searchJmesPath(value, transformerPath);
      const option = {
        id: transformed.value,
        modelId: transformed.modelId,
        version: transformed.version,
        _formDisplayValue: transformed.label,
      };

      return {
        ...option,
        _meta: { ...option, ...transformed },
      };
    }

    // Transform from full object to IReferenceValue
    const option = {
      id: value.id,
      modelId: value.modelId,
      version: value.version,
      _formDisplayValue: value.data?.name || value._formDisplayValue || '',
    };
    return {
      ...option,
      _meta: option,
    };
  } catch (error) {
    console.error(
      'Error transforming value with transformer: ',
      transformer,
      error
    );
    return value;
  }
};
